import sanitizeHtml from 'sanitize-html'

import type { IOptions } from 'sanitize-html'

const allowedHtmlAttributes: IOptions = {
  allowedAttributes: {
    Badge: ['variant', 'children'],
    Reference: ['id'],
    RiskIndicator: ['variant', 'children'],
    details: ['open'],
    document: ['topId', 'label', 'citation', 'documentId', 'sectionId', 'sectionTitle', 'title'],
  },
  allowedTags: [
    'Badge',
    'details',
    'document',
    'Reference',
    'RiskIndicator',
    'summary',
    'ThrowError',
  ],
  parser: {
    lowerCaseAttributeNames: false,
    lowerCaseTags: false,
  },
  selfClosing: ['document', 'br', 'Reference'],
}

export const getSanitizedContent = (content: string) => {
  const sanitizedContent = sanitizeHtml(content, allowedHtmlAttributes)
  // Restore blockquote markers that were converted to '&gt;' by the sanitizer
  const restoredBlockquotes = sanitizedContent
    .split('\n')
    .map((line) => {
      // Only restore lines that start with '&gt;' and are followed by a space or another '&gt;'
      if (/^(&gt;\s*)+/.test(line) && !/^(&gt;\s*)+--/.test(line)) {
        return line.replace(/^((&gt;\s*)+)(.*)$/, (_gtFull, gtMarkers, _spaces, lineContent) => {
          const count = gtMarkers.match(/&gt;/g)?.length ?? 0
          const prefix = Array(count).fill('>').join(' ')
          return prefix + (lineContent ? ' ' + lineContent : '')
        })
      }
      // Also handle inline blockquotes after content if(e.g., in lists)
      return line.replace(/(\/n)&gt;(\s)/g, '$1>$2')
    })
    .join('\n')

  // Consumers that render sanitized content into a React text node (or a textarea value)
  // escape a second time and show a literal '&amp;', so we decode it back here.
  return restoredBlockquotes.replace(/&amp;/g, '&')
}
